import DataFetcherTemplate from "../../hooks/fetchTemplate";
function OfferPosgrados() {
  const DataDisplayOferta = ({ data }) => (
    <>
      <div className="wrapper-academicoffer margin">
        {data.map((item, index) => (
          <div>
            <div class="programa-imagen">
              <img src={item.field_portada} alt={item.title} />
            </div>
            <div className="layout8">
              <div class="flex-start">
                <p class="tipoposgrado"> {item.field_programa}</p>

                {item.field_tag?.[0] && (
                  <p className="tag-2">{item.field_tag}</p>
                )}
              </div>
              <h3>{item.title}</h3>
              {item.field_modalidad?.[0] && (
                <p>
                  <b>Modalidad:</b> {item.field_modalidad}
                </p>
              )}

              {item.field_modalidad_carrera?.[0] && (
                <p>
                  <b>Modalidad:</b> {item.field_modalidad_carrera}
                </p>
              )}

              {item.field_duracion?.[0] && (
                <p>
                  <b>Duración:</b> {item.field_duracion}
                </p>
              )}

              {item.field_posgrado_duracion?.[0] && (
                <p>
                  <b>Duración:</b> {item.field_posgrado_duracion}
                </p>
              )}

              {item.field_posgrado_campo?.[0] && (
                <p>
                  <b>Campo del conocimiento:</b> {item.field_posgrado_campo}
                </p>
              )}

              {item.field_campo_amplio_del_conocimie?.[0] && (
                <p>
                  <b>Campo del conocimiento:</b>{" "}
                  {item.field_campo_amplio_del_conocimie}
                </p>
              )}

              {item.field_area?.[0] && (
                <p>
                  <b>Facultad:</b> {item.field_area}
                </p>
              )}

              {item.field_inicio?.[0] && (
                <p>
                  <b>Inicio de clases:</b> {item.field_inicio}
                </p>
              )}

              {item.field_enlace_contenido?.[0] && (
                <div className="wrapper-link">
                  <a
                    className="link-offer"
                    href={item.field_enlace_contenido}
                    rel="noreferrer"
                  >
                    Ver programa
                    <span className="material-icons">arrow_forward_ios</span>
                  </a>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <DataFetcherTemplate url="https://utpl.edu.ec/maestrias/services/posgrados.json">
      {(data) => <DataDisplayOferta data={data} />}
    </DataFetcherTemplate>
  );
}

export default OfferPosgrados;
